module.exports = __webpack_public_path__ + "media/src/images/mails/twitter-abf8f3e594562f7c7f233521fee40abc.png";